import Navbar from "../components/Navbar";
import PluginsSection from "../components/PluginsSection";
import CTAFooter from "../components/CTAFooter";

export default function PluginsPage() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar />
      <main>
        <PluginsSection />
        <CTAFooter />
      </main>
    </div>
  );
}
